async function getFilteredCourses(filterUrl) {
  const response = await fetch(filterUrl);
  if (response.ok) {
    const data = await response.json();
    return data.teachers;
  } else {
    throw new Error('Unable to fetch courses.');
  }
}


function objectToQueryString(obj) {
  const keyValuePairs = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];

      if (value === undefined || value === null) continue;
      if (Array.isArray(value)) {
        value = value.join(',')
      }
      const encodedPair = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

      keyValuePairs.push(encodedPair);
    }
  }

  return keyValuePairs.join('&');
}


function createFilterUrl(apiUrl, filter) {
  console.log("api url", apiUrl);
//  let filterUrl = `https://unity.artofliving.org/course-api/courses?country=in&type=country&start_date_from=${filter.start_date_from}&start_date_to=${filter.start_date_to}&is_online_event=${filter.is_online_event}`;
//let filterUrl = apiUrl + `?country=in&type=country&start_date_from=${filter.start_date_from}&start_date_to=${filter.start_date_to}&is_online_event=${filter.is_online_event}&limit=${filter.limit}`;

let filterUrl = apiUrl + '?' + objectToQueryString(filter)
  if (filter.ctypes && filter.ctypes.length > 0) {
    filterUrl += `&ctype=${filter.ctypes.join(',')}`;
  }

  return filterUrl;
}

export { getFilteredCourses, createFilterUrl };
